export default "__VITE_ASSET__7d2fd2c4__"